export default "__VITE_ASSET__cfVUO8an__"